import { CartV2ActionType } from './cartV2Types';

export const setCartInViewStatus: (status) => any =
  (status) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_V2_INVIEW,
      payload: status,
    });
  };

export const setCartErrorAlert: (status) => any =
  (status) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_ERROR_ALERT,
      payload: status,
    });
  };

export const setCartErrorAlertMsg: (msg) => any = (msg) => async (dispatch) => {
  dispatch({
    type: CartV2ActionType.SET_CART_ERROR_ALERT_MSG,
    payload: msg,
  });
};

export const setCartSubmitDisabled: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_SUBMIT_DISABLED,
      payload: boolVal,
    });
  };

export const setShowOrderItemModalAlert: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_ORDER_ITEM_MODAL_ALERT,
      payload: boolVal,
    });
  };

export const setOrderItemModalAlertMsg: (msg) => any =
  (msg) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_ORDER_ITEM_MODAL_ALERT_MSG,
      payload: msg,
    });
  };

export const setFirstAttributeWebItemVo: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_FIRST_ATTRIBUTE_WEBITEMVO,
      payload: data,
    });
  };

export const setSecondAttributeWebItemVo: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_SECOND_ATTRIBUTE_WEBITEMVO,
      payload: data,
    });
  };

export const setCurrentSelectAttributeUuid: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CURRENT_SELECT_ATTRIBUTE_UUID,
      payload: data,
    });
  };

export const setCurrentSelectAttribute: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CURRENT_SELECT_ATTRIBUTE,
      payload: data,
    });
  };

export const setCurrentSelectSecondAttribute: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CURRENT_SELECT_SECOND_ATTRIBUTE,
      payload: data,
    });
  };

export const setCartSelectedPayment: (method) => any =
  (method) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_SELECTED_PAYMENT,
      payload: method,
    });
  };

export const setCartSelectedPaymentAlert: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_SELECTED_PAYMENT_ALERT,
      payload: boolVal,
    });
  };

export const setCartPayments: (data) => any = (data) => async (dispatch) => {
  dispatch({
    type: CartV2ActionType.SET_CART_PAYMENTS,
    payload: data,
  });
};

export const setCartAfterApplyRuleVo: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_AFTER_APPLY_RULE,
      payload: data,
    });
  };

export const setAutoShowSecondAttributeModal: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_AUTO_SHOW_SECOND_ATTRIBUTE,
      payload: boolVal,
    });
  };

export const setCartCustomerName: (str) => any = (str) => async (dispatch) => {
  dispatch({
    type: CartV2ActionType.SET_CART_CUSTOMER_NAME,
    payload: str,
  });
};

export const setCartCustomerPhone: (str) => any = (str) => async (dispatch) => {
  dispatch({
    type: CartV2ActionType.SET_CART_CUSTOMER_PHONE,
    payload: str,
  });
};

export const setCartCustomerAddress: (str) => any =
  (str) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_CUSTOMER_ADDRESS,
      payload: str,
    });
  };

export const setCartCustomerInfoError: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: CartV2ActionType.SET_CART_CUSTOMER_INFO_ERROR,
      payload: boolVal,
    });
  };
